import React from "react";
import ContentCard from "../../../../UI/ContentCard/ContentCard";
import individualImg from "../../../../assests/images/indivuduality.png";

const VisionIndividuality = () => (
  <ContentCard
    title="Your individuality is the style"
    id="individual"
    image={individualImg}
    imageTitle="Everybody is Unique"
    frontText="We believe that everybody is unique and deserves to be    acknowledged as an individual."
    backTextOne="We believe in a free unisex
        fashion environment where the only thing not tolerated is intolerance itself. Rather than a few big corporates,
        the people themselves should define their styles and trends.
        For many reasons we are no fans of mass production. The most obvious one: hundreds of thousands of the same garment
        on the market simply is a contradiction to billions of unique people with different tastes and preferences.
        We want to offer an affordable opportunity for everybody to wear their own style."
  />
);

export default VisionIndividuality;



// WEBPACK FOOTER //
// ./src/components/Pages/Vision/Content/VisionIndividuality.js